export abstract class ErrorConsts {
  static readonly Email = 'Enter a valid username';
  static readonly Password = 'Enter valid password';
  static readonly PIN = 'Enter valid pin';
  static readonly PIN_MISMATCH = 'Pin missmatch';
  static readonly FIRST_NAME = 'Enter valid first name';
  static readonly LAST_NAME = 'Enter valid last name';
  static readonly FIELD_BLANK = '* Required';
  static readonly PIN_LENGTH = '* PIN length must should be of 4';
  static readonly INVALID_PIN = 'Invalid PIN';
  static readonly USERNAME = "Enter a valid username"
  static readonly NEW_PASSWORD = "Enter a valid new password (minimum 8 characters)"
  static readonly CONFIRM_PASSWORD = "Enter confirm password (minimum 8 characters)"
  static readonly CURRENT_PASSWORD = "Enter a valid current password "
  static readonly MESSAGE_SUBJECT = "Subject is required"
}